export enum TranslationSectionType {
  CUSTOM = 'custom',
  SYSTEM = 'system'
}
